import { render, staticRenderFns } from "./simple-driver-info.vue?vue&type=template&id=7924c2ad&scoped=true&"
import script from "./simple-driver-info.vue?vue&type=script&lang=js&"
export * from "./simple-driver-info.vue?vue&type=script&lang=js&"
import style0 from "./simple-driver-info.vue?vue&type=style&index=0&id=7924c2ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7924c2ad",
  null
  
)

export default component.exports